import { render, staticRenderFns } from "./Container.vue?vue&type=template&id=4b78a6dd"
var script = {}
import style0 from "./Container.vue?vue&type=style&index=0&id=4b78a6dd&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports